<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h2 class="text-lg font-bold mb-4">Добавить модуль</h2>
      <form @submit.prevent="submitForm">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Название</label>
          <input
            v-model="formData.name"
            type="text"
            required
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите название модуля"
          />
        </div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Тип модуля</label>
          <select
            v-model="formData.typeId"
            required
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="" disabled>Выберите тип</option>
            <option v-for="type in moduleTypes" :key="type.id" :value="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>
        <div class="flex justify-end space-x-2">
          <button
            type="button"
            @click="closeModal"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Отмена
          </button>
          <button
            type="submit"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Сохранить
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      formData: {
        name: '',
        typeId: '', // ID выбранного типа модуля
      },
      moduleTypes: [], // Список типов модулей
      loading: true, // Флаг загрузки типов модулей
    };
  },
  created() {
    this.fetchModuleTypes();
  },
  methods: {
    fetchModuleTypes() {
      axios
        .post('/api/moduleType/getModuleTypes')
        .then((response) => {
          this.moduleTypes = response.data.data; // Сохраняем список типов модулей
          this.loading = false;
        })
        .catch((error) => {
          console.error('Ошибка при загрузке типов модулей:', error);
          this.loading = false;
        });
    },
    show() {
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        name: '',
        typeId: '',
      };
    },
    submitForm() {
      if (!this.formData.typeId) {
        alert('Пожалуйста, выберите тип модуля.');
        return;
      }

      axios
        .post('/api/module/createOrUpdateModule', {
          name: this.formData.name,
          module_type_id: this.formData.typeId, // Передаем ID типа модуля
        })
        .then(() => {
          this.$emit('module-added'); // Оповещаем родительский компонент
          this.closeModal();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
